import { useEffect, useState } from "react";
import { HomeHeader } from "@/components/home/HomeHeader";
import { Hero } from "@/components/home/Hero";
import { ProofOfWork } from "@/components/home/ProofOfWork";
import { VideoDemo } from "@/components/home/VideoDemo";
import { Industries } from "@/components/home/Industries";
import { Features } from "@/components/home/Features";
import { Walkthroughs } from "@/components/home/Walkthroughs";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Pricing } from "@/components/home/Pricing";
import { Faq } from "@/components/home/Faq";
import { Contact } from "@/components/home/Contact";
import { CtaBand, HomeFooter } from "@/components/home/HomeFooter";
import { CompanySignupDialog } from "@/components/home/CompanySignupDialog";
import { InvoicesNew } from "@/components/home/InvoicesNew";
import { MakeItYours } from "@/components/home/MakeItYours";
import { EarlyDays } from "@/components/home/EarlyDays";
import { GrowLadder } from "@/components/home/GrowLadder";
import { goTo } from "@/components/home/homeData";
import { useSeo } from "@/seo/useSeo";
import { useTrackVisit } from "@/lib/track";
import { useGoogleTag } from "@/lib/gtag";

export default function Home() {
  const [signup, setSignup] = useState(false);
  const [topic, setTopic] = useState("setup");
  const start = () => setSignup(true);
  const feedback = () => { setTopic("feedback"); goTo("contact"); };
  useSeo("/");
  useTrackVisit("/");
  useGoogleTag("/");
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id && !id.includes("=")) setTimeout(() => goTo(id), 250);
    else window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A] text-left" data-testid="home-page">
      <HomeHeader onStart={start} />
      <main>
        <Hero onStart={start} />
        <VideoDemo />
        <InvoicesNew onStart={start} />
        <ProofOfWork />
        <Industries />
        <Features />
        <GrowLadder onStart={start} />
        <MakeItYours />
        <Walkthroughs />
        <HowItWorks onStart={start} />
        <Pricing onStart={start} num="07" />
        <Faq num="08" />
        <EarlyDays onFeedback={feedback} />
        <Contact topic={topic} onTopic={setTopic} />
        <CtaBand onStart={start} />
      </main>
      <HomeFooter />
      <CompanySignupDialog open={signup} onOpenChange={setSignup} />
    </div>
  );
}
